import React from 'react'
import type { FC } from 'react'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { getUser } from '@homeviews/store'

export const UserGuidingInit: FC = () => {
  const user = useSelector(getUser)
  const userGuidingIdentifiedRef = useRef(false)
  const containerId = process.env.NX_USER_GUIDING_CONTAINER_ID

  /* eslint-disable */
  useEffect(() => {
    if (!containerId) return
    // userGuiding embed JS taken from: https://panel.userguiding.com/settings/containers
    // @ts-ignore:next-line
    (function(g,u,i,d,e,s){g[e]=g[e]||[];var f=u.getElementsByTagName(i)[0];var k=u.createElement(i);k.async=true;k.src='https://static.userguiding.com/media/user-guiding-'+s+'-embedded.js';f.parentNode.insertBefore(k,f);if(g[d])return;var ug=g[d]={q:[]};ug.c=function(n){return function(){ug.q.push([n,arguments])};};var m=['previewGuide','finishPreview','track','identify','triggerNps','hideChecklist','launchChecklist'];for(var j=0;j<m.length;j+=1){ug[m[j]]=ug.c(m[j]);}})
    (window,document,'script','userGuiding','userGuidingLayer',containerId);
  }, [])

  // @ts-ignore:next-line
  if (containerId && !userGuidingIdentifiedRef.current && user?.id && window?.userGuiding) {
    // userGuiding.identify documentation available here:
    // https://help.userguiding.com/en/articles/2824058-how-can-i-enable-user-identification#userguidingidentifyuserid-customattributes
    // @ts-ignore:next-line
    window?.userGuiding.identify(user.id, {
      name: user.name,
      email: user.email,
    })
    userGuidingIdentifiedRef.current = true
  }
  /* eslint-enable */

  return null
}
